import type { ThemeUIStyleObject } from '@theme-ui/core';

type StyleConfig = {
	checked: boolean;
	highlight?: string;
	borderBackgroundColor: string;
	borderColor: string;
	backgroundColor: string;
};

export const containerStyles = ({
	checked,
	borderBackgroundColor,
	borderColor,
}: Pick<StyleConfig, 'checked' | 'borderBackgroundColor' | 'borderColor'>): ThemeUIStyleObject => ({
	borderRadius: 12,
	p: '2px',
	boxShadow: checked ? 'elevatedSelected' : 'low',
	cursor: 'pointer',
	background: borderBackgroundColor,
	border: checked ? 'none' : '2px solid',
	margin: checked ? '2px' : 0,
	borderColor,
});

export const contentBoxStyles = ({
	checked,
	highlight,
	backgroundColor,
}: Pick<StyleConfig, 'checked' | 'highlight' | 'backgroundColor'>): ThemeUIStyleObject => ({
	variant: 'bordered',
	p: 10,
	backgroundColor,
	...(highlight
		? { borderRadius: 'standard', borderTopLeftRadius: 0, borderTopRightRadius: 0 }
		: { borderRadius: 'standard' }),
	...(checked ? { borderWidth: 2 } : {}),
	borderColor: checked ? 'secondary-blue' : 'neutral-grey400',
	borderWidth: 0,
	border: 'none',
	borderRadius: 11, // Parent box has borderRadius: 12, subtract 1px to avoid overlap
	px: 32,
	pb: 16,
	pt: highlight ? 12 : 16,
	// Hide radio input while keeping label accessible for screen readers
	'input[type="radio"]': {
		position: 'absolute',
		width: 1,
		height: 1,
		padding: 0,
		margin: -1,
		overflow: 'hidden',
		clip: 'rect(0, 0, 0, 0)',
		whiteSpace: 'nowrap',
		border: 0,
	},
});

export const radioStyles: ThemeUIStyleObject = {
	accentColor: 'sunrise.semantic.fill.accent.primary.strong',
	height: '18px',
	marginTop: '2px',
	width: '18px',
};

export const labelContainerStyles: ThemeUIStyleObject = {
	cursor: 'pointer',
};

export const messageContainerStyles: ThemeUIStyleObject = {
	paddingTop: '8px',
	gap: '8',
	flexDirection: 'column',
};

export const messageTextStyles: ThemeUIStyleObject = {
	lineHeight: '20px',
	fontSize: 14,
	fontWeight: 400,
};
